module.exports = __webpack_public_path__ + "img/dolonskaya.d376debd.jpg";